// extracted by mini-css-extract-plugin
module.exports = {"mortgage":"_6f25b66c20--mortgage--2ph0m","list":"_6f25b66c20--list--2F3pp"};